export default __webpack_public_path__ + "static/media/verification.d92959a6.svg";